<template>
	<div v-if="this.product" id="searchResultProductCell" class="link flexcenter"
		style="flex-direction: column;align-items: start;border:0px solid blue;" @click="showProductDetails()"
		:title="this.title">

		<!-- produkt bild -->
		<ProductSearchImage :fileName="product.image" class="flexcenter" :parentTitle="this.title" />
		<div style="overflow:hidden;max-height: 100%;flex-grow:1;">


			<b style="font-size:80%;color:grey;cursor:initial;" @click.stop="(() => { })">{{ this.formatArtnr(this.product.artnr) }}</b><br />
			<b style="font-size:90%">{{ this.product.manufactorName }}</b> <span style="font-size:90%">{{ this.getName
				}}</span>
		</div>

		<div style="height: 24px;width:100%;text-align: left;">
			<b style="font-size:100%;color:grey;width:100%;">{{ this.formatPrice(this.product) }}</b>
		</div>
		<!-- score -->
		<SearchResultProductScore :searchEntity="searchEntity" v-if="this.debug" />
	</div>


</template>
<script>
import ProductSearchImage from './ProductSearchImage.vue';
import SearchResultProductScore from './SearchResultProductScore.vue';
import { productMixin } from '@/mixins/productMixin';

//import SelectManufactor from '@/components/product/search/SelectManufactor.vue';
//import { STORE_GETTER } from '@/store/store';

export default {
	name: "SearchResultProductCell",
	components: { SearchResultProductScore, ProductSearchImage },
	mixins: [productMixin],
	props:{
		productId:Number,
		searchEntity: Object,
		parentTitle: String
	},
	data() {
		return {
			showDetails: false,
	
		};
	},
	computed: {

		title(){
			if (this.debug){
				return this.parentTitle + "\nSearchResultProductCell: score: " + this.searchEntity?.search?.totalScore
			}else if(this.product){
				return ""+ this.product.artnr + " " + this.product.name
			}

			return "";
			
		},

		product(){
			return this.$store.state.productStore.data.productList[this.productId]
		},

		get() {
			//return this.$store.state.productStore.data.productList.filter(product => product !== null);
			//return this.$store.getters[STORE_GETTER.UNREAD_ERROR_MESSAGE]
			return 1

		},

		getName(){

			const name = this.product?.name

			return name.substring(0, 55);

		}


	},
	watch: {
		//filterInput: function (filter) {
		//	console.log("FP: watcher: ", filter);
		//}
	},
	methods: {

		showProductDetails() {
			this.$emit("showProductDetails", this.product)
			//this.$router.push('/product/' + this.productId + "/" + this.product.urlKey)

		},

		// this.$store.commit(STORE_COMMIT.SET_PAGE_MENU_OPEN, false);

		// this.$store.dispatch({ type: PRODUCT_STORE_ACTION.TEST_GET_PRODUCT_LIST, data: {} });


	},
	created() {

	}
};
</script>

<style scoped>
div#searchResultProductCell{
	border-radius: 5px;
	padding:5px;
	margin-bottom:5px;
}
</style>